// extracted by mini-css-extract-plugin
export default {"internshipList":"internshipPage_internshipList__JANEF","internshipCard":"internshipPage_internshipCard__m0ATu"};